import React, { useEffect, useState } from "react";
import { Grid, Paper, Typography, CircularProgress } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import ProfileSection from "../ProfileSection";
import DynamicTable from "../customComponents/DynamicTable";
import DetailsTable from "../customComponents/DetailsTable";
import CustomTabs from "../customComponents/CustomTabs";
import DynamicFormModal from "../customComponents/DynamicFormModal";
import AddChargerButton from "../buttonComponents/AddChargerButton";
import SearchButton from "../buttonComponents/SearchButton";
import ExportExcel from "../buttonComponents/ExportExcel";
import DownloadButton from "../buttonComponents/DownloadButton";
import * as XLSX from "xlsx";
import { useSelector, useDispatch } from "react-redux";
// import CustomMonthYearPicker from "../customComponents/CustomMonthYearPicker";
import FacilityFilterBtn from "../FacilityFilter";
import CustomBox from "../customComponents/CustomBox";
import { fetchUserTableData } from "../../slice/UserTableSlice";
import NewDatePicker from "../NewDatePicker";

const UserManagement = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchedUserData, setSearchedUserData] = useState([]);
  const [tableSearchText, setTableSearchText] = useState("");
  const [isDynamicModalOpen, setIsDynamicModalOpen] = useState(false);
  const [dynamicModalType, setDynamicModalType] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [showDetails, setShowDetails] = useState(false);
  const { selectedFacility } = useSelector(state => state.stationList);

  const userTableData = useSelector((state) => state.userTable?.data?.data);
  const userDetailsData = useSelector((state) => state.userDetails?.data?.data);
  const userStatus = useSelector((state) => state.userTable);
  const userDetailsStatus = useSelector((state) => state.userDetails);

  const dispatch = useDispatch();

  const isTableLoading = userStatus.isLoading || userDetailsStatus.isLoading;

  const apiTabs = userTableData && userTableData.tabs ? userTableData.tabs : [];

  useEffect(() => {
    const currentTabData = userTableData?.tabs[tabValue];
    setSearchedUserData(currentTabData ? currentTabData.table_content : []);
  }, [userTableData, tabValue]);

  const handleTabChange = (_event, newValue) => {
    setTabValue(newValue);
    const currentTabData = apiTabs[newValue];
    if (currentTabData && currentTabData.table_content) {
      setSearchedUserData(currentTabData.table_content);
    }
  };

  const handleisFabModalOpen = () => {
    const newApiCallType = "addCharger";
    localStorage.setItem("dynamicModalType", newApiCallType);
    setDynamicModalType(newApiCallType);
    setIsDynamicModalOpen(true);
  };

  const handleShowLogsChange = (value) => {
    setShowDetails(value);
  };

  const handleBackArrowClick = () => {
    setShowDetails(false);
    setTableSearchText((prevSearchText) => prevSearchText);
  };

  const handleSearch = (searchText) => {
    setTableSearchText(searchText);
    if (searchText.trim() === "") {
      const currentTabData = userTableData?.tabs[tabValue];
      if (currentTabData && currentTabData.table_content) {
        setSearchedUserData(currentTabData.table_content);
      }
    } else {
      const currentTabData = userTableData?.tabs[tabValue];
      if (currentTabData && currentTabData.table_content) {
        const filteredUserData = currentTabData.table_content.filter((data) => {
          const searchTextLowerCase = searchText.toLowerCase();
          return Object.values(data).some(value => {
            if (typeof value === "string") {
              return value.toLowerCase().includes(searchTextLowerCase);
            } else if (typeof value === "number") {
              return value.toString().toLowerCase().includes(searchTextLowerCase);
            } else if (value && typeof value === "object") {
              return Object.values(value).some(val => {
                if (typeof val === "string") {
                  return val.toLowerCase().includes(searchTextLowerCase);
                } else if (typeof val === "number") {
                  return val.toString().toLowerCase().includes(searchTextLowerCase);
                }
                return false;
              });
            }
            return false;
          });
        });

        setSearchedUserData(filteredUserData);
      }
    }
  };


  const handleSearchButton = (tabName, searchText) => {
    switch (tabName) {
      case "Users":
        handleSearch(searchText);
        break;
      default:
        break;
    }
  };

  const handleExportToExcelClick = () => {
    const ws = XLSX.utils.json_to_sheet([]);
    const wb = XLSX.utils.book_new();

    const currentTabData = userTableData.tabs[tabValue];
    let buttonTabs = [];
    if (Array.isArray(currentTabData.table_content) && currentTabData.table_content.length > 0) {
      const values = Object.entries(currentTabData.table_content[0])
      values?.forEach(item => {
        if (item[1]?.type === "button" || item[1]?.type === "toggle")
          buttonTabs.push(item[0])
      })
    }

    const headers = currentTabData.headers
      .filter(
        (header) =>
          header.id !== "id" && header.id !== "edit" && header.id !== "currency" && !buttonTabs.includes(header.id)
      )
      .map((header) => header?.label);

    // Add headers to the worksheet
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });

    const tableContent = currentTabData.table_content.map((item) => {
      const rowData = currentTabData.headers
        .filter(
          (header) =>
            header.id !== "id" &&
            header.id !== "edit" &&
            header.id !== "currency" &&
            !buttonTabs.includes(header.id)
        )
        .map((header) => {
          const value = item[header.id];
          return typeof value === "object" ? value?.label : value;
        });
      return rowData;
    });

    // Add table content to the worksheet
    XLSX.utils.sheet_add_aoa(ws, tableContent, { origin: "A2" });

    const sheetName = currentTabData.name || "Sheet1";
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    // Save Excel file
    const fileName = `${selectedFacility?.name?.toLowerCase()}_users.xlsx`;
    XLSX.writeFile(wb, fileName);
  };

  const renderButtons = () => {
    const currentTabData = apiTabs[tabValue];

    if (currentTabData && currentTabData.filters_and_buttons) {
      const placeholder = `Search ${currentTabData.name || "Item"}`;
      return currentTabData.filters_and_buttons.map((button, index) => {
        switch (button) {
          case "Add Charger":
            return (
              <AddChargerButton
                key={index}
                onClick={() => handleisFabModalOpen()}
              />
            );
          case "Search":
            return (
              <SearchButton
                key={index}
                placeholder={placeholder}
                handleOnSearch={(searchText) =>
                  handleSearchButton(currentTabData.name, searchText)
                }
                value={tableSearchText}
              />
            );
          case "Export to Excel":
            return (
              <ExportExcel key={index} onClick={handleExportToExcelClick} />
            );
          case "Download":
            return (
              <DownloadButton key={index} onClick={handleExportToExcelClick} />
            );
          default:
            return null;
        }
      });
    }
  };

  useEffect(() => {
    dispatch(fetchUserTableData(0));
  }, [dispatch]);

  return (
    <>
      <Grid container rowSpacing={3} columnSpacing={3} alignItems='center' style={{ backgroundColor: "white", marginBottom: "20px" }}>
        <Grid item xs={8} style={{ flexGrow: 1, padding: '0 20px', alignItems: 'center', display: "flex" }}>
          <Typography variant="h4" fontSize="20px" fontWeight="600">
            User Management - List
          </Typography>
        </Grid>
        <Grid item xs={4} style={{ paddingTop: "5px" }}>
          <ProfileSection />
        </Grid>
      </Grid>
      <Grid
        container
        rowSpacing={3}
        columnSpacing={3}
        sx={{ marginTop: 1, marginLeft: "-35px" }}
      >
        {isTableLoading ? (
          <Grid sx={{ position: "absolute", top: "50%", left: "50%" }}>
            <CircularProgress />
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            sx={{ paddingTop: "0" }}
            style={{ paddingTop: "0" }}
          >
            <Grid item xs={12}>
              <Paper
                sx={{
                  borderRadius: "16px",
                  background: "none",
                  boxShadow: "none",
                }}
              >
                <Grid
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    alignSelf: "stretch",
                  }}
                >
                  <Grid sx={{ width: "100%" }}>
                    <Grid
                      container
                      mb={2}
                      columnSpacing={2}
                      alignItems="flex-end"
                    >
                      {/* <Grid item>
                        <CustomMonthYearPicker />
                      </Grid> */}
                      <Grid item>
                        <FacilityFilterBtn />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      rowSpacing={3}
                      columnSpacing={3}
                      sx={{ marginBottom: 2 }}
                    >
                      {userTableData && userTableData?.cards && Object.entries(userTableData?.cards).map(([key, value]) => (
                        <Grid item key={key}>
                          <CustomBox cardText={key} cardValue={value} />
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
                {showDetails ? (
                  <>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        paddingTop: "16px",
                        paddingBottom: "32px",
                      }}
                    >
                      <ArrowBack
                        sx={{ cursor: "pointer" }}
                        onClick={handleBackArrowClick}
                      />
                      <Typography
                        sx={{
                          color: "var(--light-mode-gray-80, #001233)",
                          fontFamily: "Inter",
                          fontSize: "20px",
                          fontStyle: "normal",
                          fontWeight: "600",
                          lineHeight: "normal",
                        }}
                      >
                        {userDetailsData?.tabs[0].name}
                      </Typography>
                      <NewDatePicker userId={selectedUser?.id} />
                    </Grid>
                    {userDetailsData?.tabs[0]?.table_content.length > 0 && (
                      <Grid
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                      </Grid>
                    )}
                    <DetailsTable detailsData={userDetailsData} />
                  </>
                ) : (
                  <Grid style={{ background: "white", borderRadius: "16px" }}>
                    <Grid style={{ padding: "8px 16px 0 16px" }}>
                      <CustomTabs
                        formTabs={apiTabs}
                        tabValue={tabValue}
                        handleTabChange={handleTabChange}
                      />
                    </Grid>
                    <Grid
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "12px",
                        margin: "16px 16px 0 16px",
                        justifyContent: "space-between",
                      }}
                    >
                      {showDetails ? null : renderButtons()}
                    </Grid>
                    <DynamicTable
                      setSelectedData={setSelectedUser}
                      selectedData={selectedUser}
                      tabValue={tabValue}
                      searchedData={searchedUserData}
                      tabs={userTableData?.tabs}
                      onEditClick={handleisFabModalOpen}
                      onShowLogsChange={handleShowLogsChange}
                    />
                  </Grid>
                )}
              </Paper>
            </Grid>
          </Grid>
        )}
        <DynamicFormModal
          isOpen={isDynamicModalOpen}
          onClose={() => setIsDynamicModalOpen(false)}
          apiCallType={dynamicModalType}
        // id={id}
        />
      </Grid>
    </>
  );
};

export default UserManagement;
